// Holds the singleton MSAL PublicClientApplication instance so non-React modules
// (notably the global fetch interceptor) can perform a silent token refresh when
// a stored access token has expired — without waiting for a React render cycle.
// Set once from index.js right after the instance is created.

let _instance = null;

export function setMsalInstance(instance) {
  _instance = instance;
}

export function getMsalInstance() {
  return _instance;
}

// The access token issued by the interactive login itself (captured from the
// MSAL LOGIN_SUCCESS / ACQUIRE_TOKEN_SUCCESS event). completeAuth uses this as a
// fallback so a silent-acquisition failure right after login does not force a
// second interactive sign-in when we already hold a valid token.
let _lastLoginToken = null;

export function setLastLoginToken(token) {
  _lastLoginToken = token;
}

export function getLastLoginToken() {
  return _lastLoginToken;
}
